import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

// import ElementUI from 'element-ui'
import XlianUI from 'xlian-ui'
// import 'xlian-ui/lib/theme-chalk/index.css'
import '@/styles/theme/index.css'

import '@/styles/index.less' // global css

import '@/utils/versionExpireCheck.js' // 版本提醒

import App from './App'
import store from './store'
import router from './router'
import Print from 'vue-print-nb'

import '@/icons' // icon
// import '@/utils/wfConnect'
import customUpload from '@/utils/customUpload'
import { inPermission } from '@/utils'
import {
  getAsyncRoutes,
  checkPermissionCode,
  getAllButtons
} from '@/utils/routes'

import { permission, pagePermission, loadmore } from '@/directives'

import { getAccountCode, getToken } from '@/utils/auth'

// 请求
import apis from './api'
import { ACTION_TYPE } from './constants'

import dayjs from 'dayjs'

import '@/components/register-component'

var isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)
var isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
dayjs.extend(isSameOrAfter)
// import vueFilePreview from 'gxd-file-preview'

// Vue.use(vueFilePreview, {
//   pdf: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.288/build/pdf.min.js', // pdf插件
//   worker: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.288/build/pdf.worker.min.js' // pdf.work插件
// })

Vue.prototype.$api = { ...apis }
Vue.prototype.customUpload = customUpload
Vue.prototype.ACTION_TYPE = ACTION_TYPE
Vue.prototype.inPermission = inPermission

// 打印插件
Vue.use(Print)
// set ElementUI lang to EN
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(XlianUI)

Vue.config.productionTip = false

Vue.directive('permission', permission)
Vue.directive('page-permission', pagePermission)
Vue.directive('loadmore', loadmore)

export async function initRoutes() {
  const { data: permissions } = await apis.postAccountPermission()
  await apis
    .postAccountDetail({ accountCode: getAccountCode() })
    .then((res) => {
      store.dispatch('user/setUserInfo', res.data)
    })
  // console.log('permissions ', permissions.children)
  const btnCodes = getAllButtons(permissions)?.map((_) => _.permissionCode)
  store.dispatch('permission/setPermissionCodes', btnCodes)
  const permissionsCheckedList = checkPermissionCode(permissions, btnCodes)
  const accessRoutes = getAsyncRoutes(permissionsCheckedList)
  // console.log('permissionsCheckedList ', permissionsCheckedList)
  router.addRoutes(accessRoutes)
  store.dispatch('permission/setPermissionRoutes', permissionsCheckedList)
  store.dispatch(
    'permission/setTitlePath',
    getAsyncRoutes(permissions.children)
  )
  await store.dispatch('version/startListenVersionChange')
}

async function preAddRoutes() {
  return await initRoutes()
}

async function preRenderWork() {
  if (location.href.indexOf('web/login') > -1) return
  if (!getToken()) {
    location.href = location.origin + '/web/login'
    throw new Error()
  }
  try {
    await Promise.allSettled([preAddRoutes()])
  } catch (e) {
    // console.log(e)
  }
}

async function run() {
  await preRenderWork()
  new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(App)
  })
}

run()
